import React from 'react';
import { Chartify, ChartCfgDefault, ChartCfgLarge, ChartCfgStaticMixin } from '../c/Chart';
import LogoAndInfo from '../c/LogoAndInfo';
import { R } from '../routes';
import OurLogo from '../c/OurLogo';

const debug = false;

const Chart = Chartify("stock", {refresh: false}).with_chart_component_prop().wrap((props) => {
	const width = parseInt(R.get_arg("width"),10);
	const height = parseInt(R.get_arg("height"),10);
	let cfg = {
		...ChartCfgDefault,
		...ChartCfgLarge,
		...ChartCfgStaticMixin,
		margin_left: 50/2,
		margin_bottom: 75/2,
		margin_right: 50/2,
	};
	let style = {
		"width": width + "px",
		"height": height + "px",
		"paddingBottom": "77px",
	};
	if (debug) style.background = "#ff00ff";
	const { ChartComponent } = props;
	return (
		<div className="ad_opengraph_ticker" style={style}>
			<div className="d-flex flex-row pl-4 pt-3">
				<LogoAndInfo exchange={props.exchange} ticker={props.ticker} hasData={false} />
				<div className="d-flex align-self-center pr-4">
					<OurLogo dark={true}/>
				</div>
			</div>
			<ChartComponent cfg={cfg}/>
		</div>
	);
});

export default (props) => {
	let new_props = {
		...props,
		range: R.get_arg("range"),
	};
	return (
		<Chart {...new_props}/>
	);
};



// WEBPACK FOOTER //
// ./src/p/RenderOpenGraphTicker.js